import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Services = () => {
    const { t } = useLanguage();

    const services = [
        {
            icon: '🤖',
            title: t('services.list.aiImpl.title'),
            description: t('services.list.aiImpl.description')
        },
        {
            icon: '🔧',
            title: t('services.list.sysInt.title'),
            description: t('services.list.sysInt.description')
        },
        {
            icon: '📊',
            title: t('services.list.analytics.title'),
            description: t('services.list.analytics.description')
        },
        {
            icon: '🎓',
            title: t('services.list.training.title'),
            description: t('services.list.training.description')
        },
        {
            icon: '🔒',
            title: t('services.list.security.title'),
            description: t('services.list.security.description')
        },
        {
            icon: '⚙️',
            title: t('services.list.customDev.title'),
            description: t('services.list.customDev.description')
        },
    ];

    const styles = {
        section: {
            padding: '100px 32px',
            backgroundColor: '#F9F9F9',
        },
        container: {
            maxWidth: '1400px',
            margin: '0 auto',
        },
        header: {
            textAlign: 'center',
            marginBottom: '60px',
        },
        h2: {
            fontSize: '48px',
            fontWeight: '800',
            marginBottom: '16px',
            color: '#2B2B2B',
        },
        highlight: {
            color: '#3457D5',
        },
        subtext: {
            fontSize: '20px',
            color: '#6E6E6E',
            maxWidth: '800px',
            margin: '0 auto',
            lineHeight: '1.7',
        },
        grid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
            gap: '32px',
        },
        card: {
            backgroundColor: '#FFFFFF',
            padding: '40px',
            borderRadius: '20px',
            border: '1px solid #E5E5E5',
            transition: 'all 0.3s',
        },
        icon: {
            fontSize: '48px',
            marginBottom: '20px',
            display: 'block',
        },
        cardTitle: {
            fontSize: '24px',
            fontWeight: '700',
            color: '#2B2B2B',
            marginBottom: '12px',
        },
        cardDesc: {
            fontSize: '16px',
            color: '#6E6E6E',
            lineHeight: '1.7',
        },
    };

    const isMobile = window.innerWidth < 768;
    if (isMobile) {
        styles.section.padding = '60px 20px';
        styles.h2.fontSize = '32px';
        styles.grid.gridTemplateColumns = '1fr';
    }

    return (
        <section style={styles.section} id="services">
            <div style={styles.container}>
                <div style={styles.header}>
                    <h2 style={styles.h2}>
                        {t('services.title')}<span style={styles.highlight}>{t('services.titleHighlight')}</span>
                    </h2>
                    <p style={styles.subtext}>
                        {t('services.subtext')}
                    </p>
                </div>

                <div style={styles.grid}>
                    {services.map((service, index) => (
                        <div
                            key={index}
                            style={styles.card}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-8px)';
                                e.currentTarget.style.boxShadow = '0 20px 40px rgba(52,87,213,0.15)';
                                e.currentTarget.style.borderColor = '#3457D5';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = 'none';
                                e.currentTarget.style.borderColor = '#E5E5E5';
                            }}
                        >
                            <span style={styles.icon}>{service.icon}</span>
                            <h3 style={styles.cardTitle}>{service.title}</h3>
                            <p style={styles.cardDesc}>{service.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Services;
